declare global {
	interface Window {
		__STUDY_RECOMMENDATION_PARAM__?: OpenComponentParams;
	}
}

export interface OpenComponentParams {
	theme?: string;
	context?: Context;
	env?: string;
	sliderCount?: string;
	recommendation_base_url?: string;
	bff?: BFFConfig;
	groupName?: string;
	groupId?: number;
	questionId?: number;
}

export type Context = "CSHP" | "QnA" | "myQnA" | "myTBS";

export interface BFFConfig {
	retry: {
		qna_recommendations: number;
		tbs_recommendations: number;
		recent_activity: number;
	};
}

export let params: OpenComponentParams = {};

if (typeof window !== "undefined" && window.__STUDY_RECOMMENDATION_PARAM__) {
	params = window.__STUDY_RECOMMENDATION_PARAM__;
	delete window.__STUDY_RECOMMENDATION_PARAM__;
}

if (!params.context) {
	params.context = "CSHP";
}
